import { render } from "./AddCommandForm.vue?vue&type=template&id=185b0b5c"
import script from "./AddCommandForm.vue?vue&type=script&lang=js"
export * from "./AddCommandForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__